import { render, staticRenderFns } from "./TicketAcaoObjetoEdit.vue?vue&type=template&id=065f9057"
import script from "./TicketAcaoObjetoEdit.vue?vue&type=script&lang=js"
export * from "./TicketAcaoObjetoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports